import axios from "axios";
import {ConsoleLog} from "./ConsoleHelper";
import {deleteCookie} from "./cookieHelper";
import {updateHeaders} from "./AxiosConfig";
import {COOKIE_AUTHTOKEN} from "../const/dataEnum";

/**
 * Get Http Request function with Promise using axios
 * @deprecated please use callAPI
 * @param {String} address
 * @param  {...any} param
 * @returns {Promise}
 */
export function GetRequest(dispatch, address, ...param) {
  return new Promise((resolve, reject) => {
    ConsoleLog(`[Get Request] => ${address}`, ...param, {param});
    axios
      .get(address, ...param)
      .then((response) => {
        ConsoleLog(`[Get Response] => ${address}`, response);
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        // ConsoleError(`[Get Error] => ${address}`, error, error.response);
        if (error.response && error.response.status === 401) {
          ConsoleLog("Unauthorized");
          deleteCookie(COOKIE_AUTHTOKEN);
          dispatch(updateHeaders());
        }
        reject(error);
      });
  });
}

/**
 * Post Http Request function with Promise using axios
 * @deprecated please use callAPI
 * @param {String} address
 * @param  {...any} param
 * @returns {Promise}
 */
export function PostRequest(dispatch, address, ...param) {
  return new Promise((resolve, reject) => {
    ConsoleLog(`[Post Request] => ${address}`, ...param);
    axios
      .post(address, ...param)
      .then((response) => {
        ConsoleLog(`[Post Response] => ${address}`, response);
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        // ConsoleError(`[Post Error] => ${address}`, error);
        if (error.response && error.response.status === 401) {
          ConsoleLog("Unauthorized");
          deleteCookie(COOKIE_AUTHTOKEN);
          dispatch(updateHeaders());
        }
        reject(error);
      });
  });
}

/**
 * Put Http Request function with Promise using axios
 * @deprecated please use callAPI
 * @param {String} address
 * @param  {...any} param
 * @returns {Promise}
 */
export function PutRequest(dispatch, address, ...param) {
  return new Promise((resolve, reject) => {
    ConsoleLog(`[Put Request] => ${address}`, ...param);
    axios
      .put(address, ...param)
      .then((response) => {
        ConsoleLog(`[Put Response] => ${address}`, response);
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        // ConsoleError(`[Put Error] => ${address}`, error);
        if (error.response && error.response.status === 401) {
          ConsoleLog("Unauthorized");
          deleteCookie(COOKIE_AUTHTOKEN);
          dispatch(updateHeaders());
        }
        reject(error);
      });
  });
}

/**
 * Delete Http Request function with Promise using axios
 * @deprecated please use callAPI
 * @param {String} address
 * @param  {...any} param
 * @returns {Promise}
 */
export function DeleteRequest(dispatch, address, ...param) {
  return new Promise((resolve, reject) => {
    ConsoleLog(`[Delete Request] => ${address}`, ...param);
    axios
      .delete(address, ...param)
      .then((response) => {
        ConsoleLog(`[Delete Response] => ${address}`, response);
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        // ConsoleError(`[Delete Error] => ${address}`, error);
        if (error.response && error.response.status === 401) {
          ConsoleLog("Unauthorized");
          deleteCookie(COOKIE_AUTHTOKEN);
          dispatch(updateHeaders());
        }
        reject(error);
      });
  });
}
